import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import SummaryApi from "../../common";
import NotificationModal from "./NotificationModal";  // Import the modal component

const AllNotifications = () => {
  const [notifications, setNotifications] = useState([]); // State to hold notifications
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [selectedNotification, setSelectedNotification] = useState(null); // State for selected notification for editing
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

  // API call to get notifications
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await fetch(SummaryApi.getAllNotification.url, {
          method: "GET",
        });
        const data = await response.json();

        if (data.status) {
          setNotifications(data.data); // Set the notifications data
        } else {
          setError("No notifications available");
        }
      } catch (err) {
        setError(err.message); // Set the error if there is an issue
      } finally {
        setLoading(false); // End the loading state
      }
    };

    fetchNotifications();
  }, []); // Empty dependency array to run only once on mount

  const handleEditClick = (notification) => {
    console.log("Selected Notification for Edit:", notification); // Debug log
    setSelectedNotification(notification);
    setIsModalOpen(true); // Open the modal
  };
  

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedNotification(null); // Clear selected notification when closing modal
  };

  const handleUpdateNotification = (updatedNotification) => {
    setNotifications(
      notifications.map((notification) =>
        notification.notification_id === updatedNotification.notification_id
          ? updatedNotification
          : notification
      )
    );
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-semibold mb-6 text-center sm:text-left">
        Notifications
      </h1>

      <nav className="text-gray-600 mb-6">
        <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="" className="hover:text-[#ffa404]">
              All Notifications
            </Link>
          </li>
        </ol>
      </nav>

      {/* Loading State */}
      {loading && <p>Loading notifications...</p>}

      {/* Error State */}
      {error && <p className="text-red-500">{error}</p>}

      {/* Render Notifications */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {!loading && !error && notifications.length > 0 ? (
          notifications.map((notification) => (
            <div
              key={notification.notification_id}
              className="bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200"
            >
              <div className="p-6">
                <div className="flex justify-between">
                  <h2 className="font-semibold text-xl text-gray-800">
                    {notification.title}
                  </h2>
                  <button
                    onClick={() => handleEditClick(notification)}
                    className="bg-orange-600 text-white p-2 rounded-[5px]"
                  >
                    Edit
                  </button>
                </div>
                <p className="text-gray-600 mt-2">{notification.details}</p>
                <div className="flex justify-between items-center mt-4">
                  <p className="text-sm text-gray-500">
                    Posted by: {notification.posted_by}
                  </p>
                  <p
                    className={`text-m font-semibold ${
                      notification.is_active === "1"
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {notification.is_active === "1" ? "Active" : "Inactive"}
                  </p>
                </div>
                <p className="text-xs text-gray-400 mt-2">
                  {new Date(notification.created_date).toLocaleString()}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center col-span-full">
            No notifications available.
          </p>
        )}
      </div>

      {/* Modal for editing notification */}
      <NotificationModal
  isOpen={isModalOpen}
  onClose={handleModalClose}
  notification={selectedNotification}
  onUpdate={handleUpdateNotification}
/>

    </div>
  );
};

export default AllNotifications;
